module.exports = __webpack_public_path__ + "img/CPMB.003e9370.png";